import { css } from "@emotion/react";

import { layers } from "@styles";

export const iconWrapper = css`
  z-index: ${layers.indexModalMax};
`;

export const validationSummary = css`
  margin-top: 2rem;
`;

export const phoneInput = css`
  width: 100%;
`;
